// Announcment Bar Animations
setInterval(function() {
    var total_length=document.querySelectorAll('.eam-custom-cart-banner-item').length;
    var announcmentbar_element=document.querySelectorAll('.eam-custom-cart-banner-item');
    for(var j=0;j<total_length;j++){
      if(announcmentbar_element[j].className.includes('eam-banner-showing')){
        announcmentbar_element[j].classList.remove('eam-banner-showing');
        if(j+1<total_length){
          announcmentbar_element[j+1].classList.add('eam-banner-showing');
        }else{
          announcmentbar_element[0].classList.add('eam-banner-showing');
        }
        var new_height=document.querySelector('.eam-custom-cart-banner-item.eam-banner-showing').clientHeight+'px';
        if(document.querySelector('.eam-custom-cart-banner-item.eam-banner-showing').clientHeight<40){
          new_height='40px';
        }
        document.querySelector('.eam-custom-cart-banner-move').style.minHeight=new_height; 
        break;
      }
    }
  
   }, 5000);
  
  // Announcment Bar Animation END
  // Cart Open
  function openMainCart(){
        opemEamCart();
  }
  function opemEamCart(){
    document.querySelector('.eam-cart-container').style.right='0px';
    document.querySelector('.eam-custom-cart-overlay').style.display="block";
    document.querySelector('body').classList.add('eam-no-scroll');
    eamcartrender();
  }
  if(eam_cart_trigger_idclass != ''){
    var all_trigger_element = document.querySelectorAll(eam_cart_trigger_idclass);
    for(var j=0;j<all_trigger_element.length;j++){
      all_trigger_element[j].addEventListener('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        opemEamCart();
      });
    }
      
  }
  
  
  
  // Cart Close
  document.querySelector('.eam-cart-close').addEventListener('click',function(){
    document.querySelector('.eam-cart-container').style.right='-1000px';
    document.querySelector('.eam-custom-cart-overlay').style.display="none";
    document.querySelector('body').classList.remove('eam-no-scroll');
  });
  
  
  document.querySelector('.eam-custom-cart-overlay').addEventListener('click',function(){
    document.querySelector('.eam-cart-container').style.right='-1000px';
    document.querySelector('.eam-custom-cart-overlay').style.display="none";
    document.querySelector('body').classList.remove('eam-no-scroll');
  });
  // Cart Close END
  
  // Input Field Link with Cart Quantity
  //plus icon
  $(document).on('click','.eam-cart-quantity-icon.eam-cart-quantity__plus-icon',function(){
    var item_line_id = $(this).parents('.eam-cart-item').data('product-line');
    var current_quantity=this.parentElement.querySelector('.eam-cart-quantity').value;
    current_quantity=parseInt(current_quantity)+1;
    this.parentElement.querySelector('.eam-cart-quantity').value=current_quantity;
    // Call Update Cart Function
    change_item_quantity(item_line_id,current_quantity);
  });
  $(document).on('click','.eam-cart-quantity-icon.eam-cart-quantity__minus-icon',function(){
    var item_line_id = $(this).parents('.eam-cart-item').data('product-line');
    var current_quantity=this.parentElement.querySelector('.eam-cart-quantity').value;
  
    current_quantity=parseInt(current_quantity)-1;
    if(current_quantity>=0){
      this.parentElement.querySelector('.eam-cart-quantity').value=current_quantity;
    }
    // Call Update Cart Function
    change_item_quantity(item_line_id,current_quantity);
  });
  
  $(document).on('click','.eam-cart-item .eam-cart-remove-item',function() {
    var item_line_id = $(this).parents('.eam-cart-item').data('product-line');
    $(this).parents('.eam-cart-remove-item-container').addClass('eam-remove-loading');
    $(this).parents('.eam-cart-remove-item-container').html(eam_loading_icon);
    var current_quantity = 0;
    change_item_quantity(item_line_id,current_quantity);
    
  });
  
  async function change_item_quantity(product_id,current_quantity){
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        async: true,
        data: {
          'line':  product_id,
          'quantity': current_quantity
        },
        dataType: 'json',
        success: addToCartOk
    });
  }
  
  function addItem(form_id) {
    if(window.location.href.includes('en-ca')){
      $.ajax({
        type: 'POST', 
        url: '/en-ca/cart/add.js',
        dataType: 'json', 
        data: $('#'+form_id).serialize(),
        success: addToCartOk
     });
    }else if(window.location.href.includes('en-au')){
      $.ajax({
        type: 'POST', 
        url: '/en-au/cart/add.js',
        dataType: 'json', 
        data: $('#'+form_id).serialize(),
        success: addToCartOk
     });
    }else{
     $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: $('#'+form_id).serialize(),
        success: addToCartOk
     }); 
    }
     
  }
  
  
  function addItemAddons(variant_id,e) {
    e.addClass('eam-addon-adding');
    e.text('Adding To Cart');
     $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: {
          id: variant_id,
          quantity: 1
        },
        success: addonsAddToCartOk,
        error: addonsAddToCartFail
     });
  }
  
  function addonsAddToCartFail(result) {
    if(result.responseJSON.status == 422){
      $('.eam-addon-adding').text('Sold Out');
      $('.eam-addon-adding').addClass('eam-ajax-outofstock');
      $('.eam-addon-adding').removeClass('eam-addon-adding');
    }
  }
  function addToCartOk(product) { 
    openMainCart();
  }
  
  function addonsAddToCartOk(product){
    // $('.eam-addon-adding').text(addon_atc_text);
    $('.eam-addon-adding').removeClass('eam-addon-adding');
    openMainCart();
    $('.eam-cart-items-container')[0].scrollIntoView({behavior: 'smooth'});
  }
  // open cart on item submit
  
  $(document).on('click','form[action="/cart/add"] [type="submit"]',function(e) {
    e.preventDefault();
    e.stopPropagation();
    var form_id=$(this).parents('form').attr('id');
    addItem(form_id);
    // // 2nd Way
    // setTimeout(function() {
    //   opemEamCart();
    // },500)
  });
  
  
  // Render Cart
  function eamcartrender() {
    jQuery.getJSON('/cart.js', function(cart) {
      let show_cart_items = true;
      if(cart.item_count == 1){
        if(cart.items[0].handle == 'free-unlimited-return-for-store-credit-or-exchanges-package-protection-valid-in-us'){
          show_cart_items = false;
        }
      }
      $('.eam-cart-adding2').removeAttr('disabled');
      $('.eam-cart-adding2').removeClass('is-loading');
      $('.eam-cart-adding2').removeClass('eam-cart-adding2');
      $('.eam-cart-addon-item-container').addClass('eam-cart-addon-empty');
      // $('.eam-cart-free-shipping-text-container .eam-cart-free-shipping-disclaimer').hide();
          RenderCartItem(cart);
      if(addon_type != 'static'){
        $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">'+eam_loading_icon+'</p>')
        $('.eam-cart-addon-heading-container').show();
        $('.eam-cart-middle-container').css('padding','0px 0px 0px');
      }
      // if(addon_type=='collection'){
      //   if(cart.items.length>0){
      //     RenderAddonsCollection(cart);
      //   }else{
      //     RenderAddonsCollection_2(cart);
      //   }
      // }else if(addon_type == 'tag_based'){
      //   if(cart.items.length>0){
      //     RenderAddonsTags(cart);
      //   }else{
      //     RenderAddonsCollection_2(cart);
      //   }
      // }
      if(cart.items.length>0 && show_cart_items){
        RenderCartAddons_2();
      }else{
        RenderAddonsCollection_2(cart);
      }
      setTimeout(() => {
        if(enable_free_gift){
          EamFreeProduct(cart);  
        }  
      }, 2000);
    });
  }
  
  function RenderCartItem2(){
     $('.eam-cart-items-container').html('<img alt="" class="eam-loading-icon" src="https://cdn.shopify.com/s/files/1/0040/8911/8838/files/eam-loading_ef515a93-a1f3-47b0-9c01-3a8708c566dc.svg?v=1632423993">');
     $.ajax({
            url: '/cart?view=eam-cart-html',
            method: 'GET',
            success: function(response) {
              // Assuming response is the HTML content fetched from the URL
              $('.eam-cart-items-container').html($(response).find('#shopify-section-eam-cart-html').html());
            }
     });
  }
  function RenderCartAddons_2(){
     $('.eam-cart-items-container').html('<img alt="" class="eam-loading-icon" src="https://cdn.shopify.com/s/files/1/0040/8911/8838/files/eam-loading_ef515a93-a1f3-47b0-9c01-3a8708c566dc.svg?v=1632423993">');
     $.ajax({
            url: '/cart?view=eam-cart-addons',
            method: 'GET',
            success: function(response) {
              $('.eam-cart-addon-item-container').html($(response).find('#shopify-section-eam-cart-html').html());
              if($('.eam-cart-addon-item-container .eam-cc-addon-product').length == 3 || $('.eam-cart-addon-item-container .eam-cc-addon-product').length < 3   ){
                $('.eam-cart-addon-item-load-more').hide();
              }
            }
     });
  }
  
  function RenderCartItem(cart) {
      var total_cart_price = current_currency + '' +(cart.total_price/100.00).toFixed(2);
      var tag_text = free_gift_text;
      var original_total_cart_price="none",cart_discount_name;
      if(cart.original_total_price>cart.total_price){
        original_total_cart_price=current_currency + '' +(cart.original_total_price/100.00).toFixed(2);
      }
      if(cart.cart_level_discount_applications.length>0){
        cart_discount_name = cart.cart_level_discount_applications[0].title;
        $('.eam-cart-subtotal-text').html('Subtotal <span class="eam-cart-discount-text" data-discount="'+cart_discount_name+'">'+cart_discount_name+'</span>');
      }
      if(!show_subtotal_cbutton){
        $('.eam-cart-subtotal-price').html('<span class="eam-cart-original-subtotal-price" data-price="'+original_total_cart_price+'">'+original_total_cart_price+'</span><span class="eam-cart-subtotal-price-text" data-price="'+total_cart_price+'">'+total_cart_price+'</span>');
        
      }else{
        $('.eam-cart-subtotal-price').html('<span class="eam-cart-original-subtotal-price" data-price="'+original_total_cart_price+'">'+original_total_cart_price+'</span><span class="eam-cart-subtotal-price-text" data-price="'+total_cart_price+'">'+checkout_button_text+' - '+total_cart_price+'</span>');
      }
      $(eam_cart_count_idclass).text(cart.item_count);
      $('.eam-cart-heading').attr('data-count','('+cart.item_count+')');
      let show_cart_items = true;
      if(cart.item_count == 1){
        if(cart.items[0].handle == 'free-unlimited-return-for-store-credit-or-exchanges-package-protection-valid-in-us'){
          show_cart_items = false;
        }
      }
      if(cart.item_count>0 && show_cart_items){
        $('.eam-cart-addon-item-container').removeClass('eam-cart-addon-empty');
        
        $('.eam-cart-bottom-container').show();
        var new_padding = document.querySelector('.eam-cart-bottom-container').offsetHeight+30;
        document.querySelector('.eam-cart-addon-item-container').style.paddingBottom=new_padding+'px';
        $('.eam-cart-empty-heading-container').remove();
        $('.eam-cart-items-container').show();
        document.querySelector('.eam-cart-items-container').innerHTML = '';
        var current_item,eam_product_title,eam_variant_title,eam_product_price,eam_original_price,current_cart_items,new_item,product_url,discount_name;
         RenderCartItem2();
        
        if( eam_shipping_enable || enable_free_gift ){
          calculateshipping(cart);
        }
      }else{
        $('.eam-cart-bottom-container').hide();
        document.querySelector('.eam-cart-addon-item-container').style.paddingBottom='0px';
        if(document.querySelector('.eam-shipping-bar')){
          document.querySelector('.eam-shipping-bar').style.width='0';
        }
        $('.eam-cart-items-container').hide();
        $('.eam-cart-empty-heading-container').remove();
        document.querySelector('.eam-cart-middle-container').innerHTML = '<div class="eam-cart-empty-heading-container"> <h2 class="eam-cart-empty-heading">'+empty_cart_text+'</h2> </div>'+document.querySelector('.eam-cart-middle-container').innerHTML;
      }
  }
  
  function calculateshipping(cart) {
    var total_cart_price = cart.total_price/100.00;
    var free_shipping_price = parseFloat(eam_shipping_price);
    var free_product_price = parseFloat(free_gift_price);
    console.log("free_product_price:"+free_gift_price);
    var current_width = (total_cart_price/free_shipping_price)*100;
    var current_amount_needed = 0;
    var shipping_text,current_text;
    var current_selected_price;
    var disclarmair_text_update = false;
    if(enable_free_gift && eam_shipping_enable){
      if(free_product_price>free_shipping_price){
          current_width = ((total_cart_price)/free_shipping_price)*100;
          current_text = eam_shipping_text;
            current_selected_price = free_shipping_price;
          if(current_width>=100){
            disclarmair_text_update = true;
            current_text = eam_product_text;
            current_selected_price = free_product_price;
            current_width = (total_cart_price/free_product_price)*100;
            if(current_width<=50){
              current_width = 60;
            }
          }else{
            current_width = current_width/2;
          }
  
      }else{
          current_width = ((total_cart_price)/free_product_price)*100;
          current_text = eam_product_text;
          current_selected_price = free_product_price;
          if(current_width>=100){
            current_text = eam_shipping_text;
            current_selected_price = free_shipping_price;
            current_width = (total_cart_price/free_shipping_price)*100;
            if(current_width<=50){
              current_width = 60;
            }
          }else{
            current_width = current_width/2;
          }
      }
      if(current_width>=100){
        if(free_product_price<free_shipping_price){
          disclarmair_text_update = true;
          document.querySelector('.eam-cart-free-shipping-disclaimer').textContent=disclaimer_free_text;
          
        }
        shipping_text = eam_free_shipping_text;
        current_width = 100.00;
        document.querySelector('.eam-cart-free-shipping-bar-container').classList.add('eam-free-shipping');
      }else{
        if(free_product_price<free_shipping_price){
          document.querySelector('.eam-cart-free-shipping-disclaimer').innerHTML=disclaimer_text;
        }
        document.querySelector('.eam-cart-free-shipping-bar-container').classList.remove('eam-free-shipping');
        current_amount_needed = current_currency +""+( current_selected_price - total_cart_price ).toFixed(2);
        shipping_text = 'SPEND <strong>'+current_amount_needed+' </strong>'+current_text;
      }
      $('.eam-cart-free-shipping-text').html(shipping_text);
      if(document.querySelector('.eam-shipping-bar')){
        document.querySelector('.eam-shipping-bar').style.width=current_width+'%';
      }
    }else{
      if(enable_free_gift){
        current_text = eam_product_text;
        current_width = (total_cart_price/free_product_price)*100;
        free_shipping_price = free_product_price;
      }else if(eam_shipping_enable){
        current_width = (total_cart_price/free_shipping_price)*100;
        current_text = eam_shipping_text;
        disclarmair_text_update = true;
      }
      if(current_width>=100){
        shipping_text = eam_free_shipping_text;
        current_width = 100.00;
        document.querySelector('.eam-cart-free-shipping-bar-container').classList.add('eam-free-shipping');
        document.querySelector('.eam-cart-addon-heading').innerHTML = 'BUY IT WITH';
        if(disclarmair_text_update){
          document.querySelector('.eam-cart-free-shipping-disclaimer').textContent=disclaimer_free_text;
        }
      }else{
        document.querySelector('.eam-cart-free-shipping-disclaimer').innerHTML=disclaimer_text;
        document.querySelector('.eam-cart-free-shipping-bar-container').classList.remove('eam-free-shipping');
        current_amount_needed = current_currency +""+( free_shipping_price - total_cart_price ).toFixed(2);
        shipping_text = 'SPEND <strong>'+current_amount_needed+' </strong>'+current_text;
        document.querySelector('.eam-cart-addon-heading').innerHTML = addon_heading;
      }
      $('.eam-cart-free-shipping-text').html(shipping_text);
      document.querySelector('.eam-shipping-bar').style.width=current_width+'%';
    }
  }
  
  // Addons JS
  
    // Show Option on Click
    
    $(document).on('click','.eam-cc-addon-product-button',function(){
      if($(this).hasClass('eam-ajax-add')){
        var variant_id = $(this).data('product-id');
        addItemAddons(variant_id,$(this));
      }else{
        // Remove Other Shown Options
          var all_addon_with_options = $('.eam-cc-addon-product .eam-cc-addon-product-bottom');
          for(var j=0;j<all_addon_with_options.length;j++){
            $(all_addon_with_options[j]).parents('.eam-cc-addon-product').removeClass('eam-show-options');
            $(all_addon_with_options[j]).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').html(addon_option_text);
            $(all_addon_with_options[j]).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').removeClass('eam-ajax-add');
            // $(all_addon_with_options[j]).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').removeClass('eam-ajax-outofstock');
            // $(all_addon_with_options[j]).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').removeClass('eam-option-not-selected');
          }
        // Show Current Selected Option
          $(this).addClass('eam-ajax-add');
          // $(this).addClass('eam-option-not-selected');
          if($(this).hasClass('eam-ajax-outofstock')){
            $(this).text(addon_oos_text);
          }else{
            $(this).text(addon_atc_text);
          }
          $(this).parents('.eam-cc-addon-product').addClass('eam-show-options');
      }
    });
  
    // Option Change JS 
    $(document).on('change','.eam-ccap-option',function() {
      var all_option_element = $(this).parents('.eam-cc-addon-product-bottom').find('.eam-ccap-option');
      var all_option_selected = false;
      var product_handle = $(this).parents('.eam-cc-addon-product').data('product-handle');
      var current_selected_options = {};
      var current_selected_options_merged;
      for ( var j = 0 ; j < all_option_element.length ; j++){
        if($(all_option_element[j])!=undefined){
          var current_value = $(all_option_element[j]).val();
          var current_option_name = $(all_option_element[j]).parents('.eam-cc-addon-product-option-container').data('product-option');
          current_selected_options[current_option_name] = current_value;
          if( j == 0 ){
            current_selected_options_merged = current_value;
          }else{
            current_selected_options_merged = current_selected_options_merged + ' / ' + current_value;
          }
          if(current_value!=null){
            all_option_selected = true;
          }else{
            all_option_selected = false;
            break;
          }
        }
      }
      if(all_option_selected){
        $(this).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').removeClass('eam-option-not-selected');
        addon_find_variants(current_selected_options_merged,product_handle,$(this).parents('.eam-cc-addon-product'));
      }else{
        $(this).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').addClass('eam-option-not-selected');
      }
    });
  
    // Finding which addon variant is selected and is it available or not
    function addon_find_variants(current_selected_options,product_handle,e) {
      jQuery.getJSON(window.Shopify.routes.root + 'products/'+product_handle+'.js', function(product) {
        for(variant in product.variants){
          var current_variant = product.variants[variant];
          if(current_variant.title == current_selected_options){
            // Changing Addon Current Image
            var variant_pice = current_currency + '' + (current_variant.price/100.00).toFixed(2);
            if(current_variant.featured_image!=null){
              var variant_image = current_variant.featured_image.src;
              if(variant_image.toLowerCase().includes('jpg')){
                variant_image = variant_image.replace('.jpg','_x180.jpg');
              }else if(variant_image.toLowerCase().includes('png')){
                variant_image = variant_image.replace('.png','_x180.png');
              }else if(variant_image.toLowerCase().includes('jpeg')){
                variant_image = variant_image.replace('.png','_x180.jpeg');
              }
              e.find('.eam-cc-addon-product-image')[0].src = variant_image;
            }

            if (window.discount_amount){
              const discount_amount = window.discount_amount;
              const discounted_price = (100 - discount_amount) * current_variant.price / 100;
              
              let original_price;
              if(current_variant.compare_at_price){
                original_price = current_variant.compare_at_price;
              }else{
                original_price = current_variant.price;
              }
              const savings = original_price - discounted_price;
              
              e.find('.eam-cc-addon-product-price span:first-child').text(theme.Currency.formatMoney(discounted_price, theme.settings.moneyFormat));
              e.find('.eam-cc-addon-product-price span:last-child').text(theme.Currency.formatMoney(original_price, theme.settings.moneyFormat));
  
            }else{
              e.find('.eam-cc-addon-product-price span:first-child').text(variant_pice);
            }

            if(current_variant.available){
              e.find('button.eam-cc-addon-product-button.eam-ajax-add').removeClass('eam-ajax-outofstock');
              e.find('button.eam-cc-addon-product-button.eam-ajax-add').data('product-id',current_variant.id);
              e.find('button.eam-cc-addon-product-button.eam-ajax-add').text(addon_atc_text);
              
            }else{
              e.find('button.eam-cc-addon-product-button.eam-ajax-add').addClass('eam-ajax-outofstock');
              e.find('button.eam-cc-addon-product-button.eam-ajax-add').text(addon_oos_text);
            }
          }
        }
      });
    }
  
    // Rendering Addons Based on Collection
    function RenderAddonsCollection(cart) {
      if(addon_collection!=''){
        jQuery.getJSON('/collections/'+addon_collection+'/products.json', function(products) {
          var k = 0;
          var all_products = products.products;
          if (all_products.length > 0){
            $('.eam-cart-addon-item-container').empty();
            for (product in all_products){
              var current_product = all_products[product];
              var cart_product_nexist = true;
              for(var l=0;l<cart.items.length;l++){
                if(cart.items[l].product_id == current_product.id){
                    cart_product_nexist=false;
                    break;
                }
              }
              if(current_product.handle == free_gift_product_handle){
                cart_product_nexist=false;
              }
              if(k==3){
                // break;
                if($('.eam-cart-addon-item-load-more').length==0){
                  $('.eam-cart-addon-item-container').append('<div class="eam-cart-addon-item-load-more">Load More</div>')
                }
    
              }
              if(current_product!=undefined && cart_product_nexist){
                k++;
                var addon_product;
                var featured_image = current_product.images[0].src;
                if(featured_image.toLowerCase().includes('jpg')){
                  featured_image = featured_image.replace('.jpg','_x180.jpg');
                }else if(featured_image.toLowerCase().includes('png')){
                  featured_image = featured_image.replace('.png','_x180.png');
                }else if(featured_image.toLowerCase().includes('jpeg')){
                  featured_image = featured_image.replace('.png','_x180.jpeg');
                }
                var price = current_currency + '' + current_product.variants[0].price;
                var atc_text = addon_atc_text;
                var first_variant_id = current_product.variants[0].id;
                var url = '/products/'+current_product.handle;
                var atc_class='eam-cc-addon-product-button eam-ajax-add';
                var eam_complete_options =  undefined;
                if(current_product.variants.length>1){
                  atc_text = addon_option_text;
                  atc_class='eam-cc-addon-product-button eam-option-not-selected';
                  eam_complete_options = find_addons_options(current_product);  
                }  
                var cprice = 'none';
                if(current_product.variants[0].compare_at_price>current_product.variants[0].price){
                  var cprice = current_currency + '' + current_product.variants[0].compare_at_price;
                  
                }
                let price_html = '<h4 class="eam-cc-addon-product-price"> <span class="money" data-currency="'+current_currency+'">'+price+'</span> <span data-cprice="'+cprice+'" class="money cprice" data-currency="'+current_currency+'">'+cprice+'</span> </h4>';
                if (window.discount_amount){
                  const discount_amount = window.discount_amount;
                  const discounted_price = (100 - discount_amount) * current_product.variants[0].price / 100;
                  
                  let original_price;
                  if(current_product.variants[0].compare_at_price){
                    original_price = current_product.variants[0].compare_at_price;
                  }else{
                    original_price = current_product.variants[0].price;
                  }
                  const savings = original_price - discounted_price;
                  price_html = `<h4 class="eam-cc-addon-product-price"> 
                                  <span class="money" data-currency="${current_currency}">${original_price}</span>
                                  <span data-cprice="${original_price}" class="money cprice" data-currency="${current_currency}">
                                  ${original_price}</span>
                                </h4>`;
                }

                if(eam_complete_options == undefined){
                  addon_product  = '<div class="eam-cc-addon-product" data-product-id="'+current_product.id+'" data-product-handle="'+current_product.handle+'"> <div class="eam-cc-addon-product-top"> <a href="'+url+'"> <img alt="" class="eam-cc-addon-product-image lazyload" src="'+featured_image+'"> </a> <div class="eam-header-price-container"> <div class="loox-rating" data-id="" data-rating="" data-raters=""></div> <a href="'+url+'"> <h4 class="eam-cc-addon-product-title">'+current_product.title+'</h4> </a> <a class="eam-cc-addon-product-price-container" href="'+url+'"> '+ price_html +' </a> <a class="eam-cc-addon-product-button-container" href="#"> <button class="'+atc_class+'" data-product-url="'+url+'" data-product-handle="'+current_product.handle+'" data-product-id="'+first_variant_id+'">'+atc_text+'</button> </a> </div> </div></div>'
                }else{
                  addon_product = '<div class="eam-cc-addon-product" data-product-id="'+current_product.id+'" data-product-handle="'+current_product.handle+'"> <div class="eam-cc-addon-product-top"> <a href="'+url+'"> <img alt="" class="eam-cc-addon-product-image lazyload" src="'+featured_image+'"> </a> <div class="eam-header-price-container"> <div class="loox-rating" data-id="" data-rating="" data-raters=""></div> <a href="'+url+'"> <h4 class="eam-cc-addon-product-title">'+current_product.title+'</h4> </a> <a class="eam-cc-addon-product-price-container" href="'+url+'"> '+ price_html +' </a> <a class="eam-cc-addon-product-button-container" href="#"> <button class="'+atc_class+'" data-product-url="'+url+'" data-product-handle="'+current_product.handle+'" data-product-id="'+current_product.id+'">'+atc_text+'</button> </a> </div> </div><div class="eam-cc-addon-product-bottom">'+eam_complete_options+'</div> </div>'
                }
                $('.eam-cart-addon-item-container').append(addon_product);
              }
            }
            if($('.eam-cc-addon-product').length==0){
              $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">Collection Complete</p>')
            }
          }else{
            $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">Collection Complete</p>')
          }
          if($('.eam-cc-addon-product').length>3){
            $('.eam-cart-addon-item-load-more').show();
          }else{
            $('.eam-cart-addon-item-load-more').hide();
          }
        });      
      }
  
    }
    
  
    function RenderAddonsCollection_2(cart) {
      $('.eam-cart-addon-heading-container').empty();
      $('.eam-cart-addon-heading-container').append('<h2 class="eam-cart-addon-heading">'+empty_addons_heading+'</h2>');
      $('.eam-cart-empty-heading-container').append('<p class="eam-empty-cart-addon-heading-text">Give your cart some love! Lets keep <br> shopping...</p><div class="empty-cart-buttons"><a href="https://pardonmyfro.com/collections/travel">SHOP BAGS</a><a href="https://pardonmyfro.com/collections/hair">SHOP PMF HAIR</a><a href="https://pardonmyfro.com/collections/kimono">SHOP APPAREL</a></div>');
      if(addon_collection_2!=''){
        jQuery.getJSON('/collections/'+addon_collection_2+'/products.json', function(products) {
          var k = 0;
          var all_products = products.products;
          if (all_products.length > 0){
            $('.eam-cart-addon-item-container').empty();
            for (product in all_products){
              var current_product = all_products[product];
              var cart_product_nexist = true;
              for(var l=0;l<cart.items.length;l++){
                if(cart.items[l].product_id == current_product.id){
                    cart_product_nexist=false;
                    break;
                }
              }
              if(current_product.handle == free_gift_product_handle){
                cart_product_nexist=false;
              }
              if(k==4){
                break;
              }
              if(current_product!=undefined && cart_product_nexist){
                k++;
                var addon_product;
                var featured_image = current_product.images[0].src;
                if(featured_image.toLowerCase().includes('jpg')){
                  featured_image = featured_image.replace('.jpg','_x180.jpg');
                }else if(featured_image.toLowerCase().includes('png')){
                  featured_image = featured_image.replace('.png','_x180.png');
                }else if(featured_image.toLowerCase().includes('jpeg')){
                  featured_image = featured_image.replace('.png','_x180.jpeg');
                }
                var price = current_currency + '' + current_product.variants[0].price;
                var atc_text = addon_atc_text;
                var first_variant_id = current_product.variants[0].id;
                var url = '/products/'+current_product.handle;
                var atc_class='eam-cc-addon-product-button eam-ajax-add';
                var eam_complete_options =  undefined;
                if(current_product.variants.length>1){
                  atc_text = addon_option_text;
                  atc_class='eam-cc-addon-product-button eam-option-not-selected';
                  eam_complete_options = find_addons_options(current_product);  
                }  
                let price_html = '<h4 class="eam-cc-addon-product-price"> <span class="money" data-currency="'+current_currency+'">'+price+'</span> </h4>';
                if (window.discount_amount){
                  const discount_amount = window.discount_amount;
                  const discounted_price = (100 - discount_amount) * current_product.variants[0].price / 100;
                  
                  let original_price;
                  if(current_product.variants[0].compare_at_price){
                    original_price = current_product.variants[0].compare_at_price;
                  }else{
                    original_price = current_product.variants[0].price;
                  }
                  const savings = original_price - discounted_price;
                  price_html = `<h4 class="eam-cc-addon-product-price"> 
                                  <span class="money" data-currency="${current_currency}">${original_price}</span>
                                  <span data-cprice="${original_price}" class="money cprice" data-currency="${current_currency}">
                                  ${original_price}</span>
                                </h4>`;
                }
                if(eam_complete_options == undefined){
                     
                   addon_product  = '<div class="eam-cc-addon-product" data-product-id="'+current_product.id+'" data-product-handle="'+current_product.handle+'"> <div class="eam-cc-addon-product-top"> <a href="'+url+'"> <img alt="" class="eam-cc-addon-product-image lazyload" src="'+featured_image+'"> </a> <div class="eam-header-price-container"> <div class="loox-rating" data-id="" data-rating="" data-raters=""></div> <a href="'+url+'"> <h4 class="eam-cc-addon-product-title">'+current_product.title+'</h4> </a> <a class="eam-cc-addon-product-price-container" href="'+url+'"> '+price_html+' </a> <a class="eam-cc-addon-product-button-container" href="#"> <button class="'+atc_class+'" data-product-url="'+url+'" data-product-handle="'+current_product.handle+'" data-product-id="'+first_variant_id+'">'+atc_text+'</button> </a> </div> </div></div>'
                }else{
                  addon_product = '<div class="eam-cc-addon-product" data-product-id="'+current_product.id+'" data-product-handle="'+current_product.handle+'"> <div class="eam-cc-addon-product-top"> <a href="'+url+'"> <img alt="" class="eam-cc-addon-product-image lazyload" src="'+featured_image+'"> </a> <div class="eam-header-price-container"> <div class="loox-rating" data-id="" data-rating="" data-raters=""></div> <a href="'+url+'"> <h4 class="eam-cc-addon-product-title">'+current_product.title+'</h4> </a> <a class="eam-cc-addon-product-price-container" href="'+url+'"> '+price_html+' </a> <a class="eam-cc-addon-product-button-container" href="#"> <button class="'+atc_class+'" data-product-url="'+url+'" data-product-handle="'+current_product.handle+'" data-product-id="'+current_product.id+'">'+atc_text+'</button> </a> </div> </div><div class="eam-cc-addon-product-bottom">'+eam_complete_options+'</div> </div>'
                }
                $('.eam-cart-addon-item-container').append(addon_product);
              }
            }
            if($('.eam-cc-addon-product').length==0){
              $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">Collection Complete</p>')
            }
          }else{
            $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">Collection Complete</p>')
          }
        });      
      }
  
    }
  
    // Render Empty Cart Addons
  
    function RenderEmptyAddons(cart){
      $('.eam-cart-middle-container').css('padding','0px 20px');
      $('.eam-cart-addon-heading-container').hide();
      $('.eam-cart-addon-item-container').empty();
      $('.eam-cart-addon-item-container').append('<div class="eam-empty-cart-addons-product-container"><a href="'+empty_cart_product_url+'" class="eam-empty-cart-addons-product-content"> <div class="eam-empty-cart-addons-product-image"> <img class="eam-empty-cart-addons-product-img" src="'+empty_cart_product_image+'"> </div> <div class="eam-empty-cart-addons-product-text-content"> <p class="eam-empty-cart-addons-product-tag">BEST SELLER</p> <h3 class="eam-empty-cart-addons-product-title">'+empty_cart_product_title+'</h3> <p class="eam-empty-cart-addons-product-price">'+empty_cart_product_price+'</p> <p class="eam-empty-cart-addons-product-text">A stylish alternative to piercings, with all the glam but without the pain, and take on and off in seconds.</p> </div> </a> <div class="eam-empty-cart-addons-benefits-content"> <div class="eam-empty-cart-addons-benefits"> <img class="eam-empty-cart-addons-benefits-img" src="//cdn.shopify.com/s/files/1/2990/1220/t/49/assets/Group-530.png?v=30693277625483854921675969731"> <p class="eam-empty-cart-addons-benefits-text">Plated in Real Gold</p> </div> <div class="eam-empty-cart-addons-benefits"> <img class="eam-empty-cart-addons-benefits-img" src="//cdn.shopify.com/s/files/1/2990/1220/t/49/assets/Group-530.png?v=30693277625483854921675969731"> <p class="eam-empty-cart-addons-benefits-text">30,000+ Happy Customers </p> </div> <div class="eam-empty-cart-addons-benefits"> <img class="eam-empty-cart-addons-benefits-img" src="//cdn.shopify.com/s/files/1/2990/1220/t/49/assets/Group-530.png?v=30693277625483854921675969731"> <p class="eam-empty-cart-addons-benefits-text">100% Money-Back Guarantee</p> </div> <div class="eam-empty-cart-addons-benefits"> <img class="eam-empty-cart-addons-benefits-img" src="//cdn.shopify.com/s/files/1/2990/1220/t/49/assets/Group-530.png?v=30693277625483854921675969731"> <p class="eam-empty-cart-addons-benefits-text">2 year warranty</p> </div> </div> </div><div class="eam-empty-cart-addons-button-content"> <div class="eam-empty-cart-addons-button"> <a href="'+empty_cart_product_url+'" class="eam-empty-cart-addons-button-text">SHOP '+empty_cart_product_title+'</a> </div> <div class="eam-empty-cart-addons-button-rating"> <img class="eam-empty-cart-addons-button-rating-image" src="//cdn.shopify.com/s/files/1/2990/1220/t/49/assets/Group-5118.png?v=35827348968533919901675970873"> <p class="eam-empty-cart-addons-button-rating-text">Rated 4.9/5 By Hockey Players</p> </div> </div> ');
      
    }
    
    // Finding Addons Options and returning them
    function find_addons_options(current_product) {
      if(current_product.options.length>=1 && current_product.options[0].values!="Default Title" && current_product.options[0].values.length>=1 ){
        var eam_options=[],eam_complete_options='';
        for(k=0;k<current_product.options.length;k++){  
          for(j=0;j<current_product.options[k].values.length;j++){
            if(j!=0){
              eam_options[k]=eam_options[k]+'<option>'+current_product.options[k].values[j]+'</option>';
            }else{
              eam_options[k]='<option>'+current_product.options[k].values[j]+'</option>';
  
            }
          }
        }
  
        for(k=0;k<current_product.options.length;k++){  
          if(current_product.options[k].values.length>=1 && current_product.options[k].values[0]!="Default Title"){
  
            if(k==0){
              eam_complete_options='<div class="eam-cc-addon-product-option-container" data-product-option="'+current_product.options[k].name+'"><select class="eam-ccap-option"><option val="eam-none" selected disabled>'+current_product.options[k].name+'</option>'+eam_options[k]+'</select></div>'
            }
            else{
              eam_complete_options=eam_complete_options+'<div class="eam-cc-addon-product-option-container" data-product-option="'+current_product.options[k].name+'"><select class="eam-ccap-option"><option val="eam-none" selected disabled>'+current_product.options[k].name+'</option>'+eam_options[k]+'</select></div>';
            }
          }
        }
      }
      return eam_complete_options;  
    }
  
    function RenderAddonsTags(cart) {
      var tag;
      var product_handle;
      var product_title;
      if(cart.items[0].handle!='routeins'){
        product_title=cart.items[0].product_title;
      }else{
        last_product_id=cart.items[1].product_id;
        product_handle=cart.items[1].handle;
        product_title=cart.items[1].product_title;
      }
      var tag='',final_url;
      if(product_title.toLowerCase().includes('bag')){
        tag = 'travel';
        final_url='/collections/'+tag+'/products.json';
      }else if(product_title.toLowerCase().includes('kimono')){
        tag = 'kimono';
        final_url='/collections/'+tag+'/products.json';
      }else if(product_title.toLowerCase().includes('bath') || product_title.toLowerCase().includes('beach') || product_title.toLowerCase().includes('duvet') || product_title.toLowerCase().includes('pillows') || product_title.toLowerCase().includes('shower') || product_title.toLowerCase().includes('fleece') || product_title.toLowerCase().includes('woven') ){
        tag = 'home';
        final_url='/collections/'+tag+'/products.json';
      }else if(product_title.toLowerCase().includes('afro') || product_title.toLowerCase().includes('detangler') || product_title.toLowerCase().includes('tooth') || product_title.toLowerCase().includes('pillows') || product_title.toLowerCase().includes('shower') || product_title.toLowerCase().includes('fleece') || product_title.toLowerCase().includes('woven') ){
        tag = 'hair';
        final_url='/collections/'+tag+'/products.json';
      }else if(product_title.toLowerCase().includes('holiday') || product_title.toLowerCase().includes('prints') ){
        tag = 'prints';
        final_url='/collections/'+tag+'/products.json';
      }else{
        final_url='/collections/shop-all/products.json';
      }
      
      jQuery.getJSON(final_url, function(products) {
        var k = 0;
        var all_products = products.products;
        if (all_products.length > 0){
          $('.eam-cart-addon-item-container').empty();
          for (product in all_products){
            var current_product = all_products[product];
            var cart_product_nexist = true;
            for(var l=0;l<cart.items.length;l++){
              if(cart.items[l].product_id == current_product.id){
                  cart_product_nexist=false;
                  break;
              }
            }
            if(current_product.handle == free_gift_product_handle){
              cart_product_nexist=false;
            }
            if(k==3){
              // break;
              if($('.eam-cart-addon-item-load-more').length==0){
                $('.eam-cart-addon-item-container').append('<div class="eam-cart-addon-item-load-more">Load More</div>')
              }
  
            }
            
            if(current_product!=undefined && cart_product_nexist){
              k++;
              var addon_product;
              var featured_image = current_product.images[0].src;
              if(featured_image.toLowerCase().includes('jpg')){
                featured_image = featured_image.replace('.jpg','_x180.jpg');
              }else if(featured_image.toLowerCase().includes('png')){
                featured_image = featured_image.replace('.png','_x180.png');
              }else if(featured_image.toLowerCase().includes('jpeg')){
                featured_image = featured_image.replace('.png','_x180.jpeg');
              }
              var price = current_currency + '' + current_product.variants[0].price;
              var atc_text = addon_atc_text;
              var first_variant_id = current_product.variants[0].id;
              var url = '/products/'+current_product.handle;
              var atc_class='eam-cc-addon-product-button eam-ajax-add';
              var eam_complete_options =  undefined;
              if(current_product.variants.length>1){
                atc_text = addon_option_text;
                atc_class='eam-cc-addon-product-button eam-option-not-selected';
                eam_complete_options = find_addons_options(current_product);  
              }  
              var cprice = 'none';
              if(current_product.variants[0].compare_at_price>current_product.variants[0].price){
                var cprice = current_currency + '' + current_product.variants[0].compare_at_price;
                
              }
              let price_html = '<h4 class="eam-cc-addon-product-price"> <span class="money" data-currency="'+current_currency+'">'+price+'</span> <span data-cprice="'+cprice+'" class="money cprice" data-currency="'+current_currency+'">'+cprice+'</span> </h4>';
                if (window.discount_amount){
                  const discount_amount = window.discount_amount;
                  const discounted_price = (100 - discount_amount) * current_product.variants[0].price / 100;
                  
                  let original_price;
                  if(current_product.variants[0].compare_at_price){
                    original_price = current_product.variants[0].compare_at_price;
                  }else{
                    original_price = current_product.variants[0].price;
                  }
                  const savings = original_price - discounted_price;
                  price_html = `<h4 class="eam-cc-addon-product-price"> 
                                  <span class="money" data-currency="${current_currency}">${original_price}</span>
                                  <span data-cprice="${original_price}" class="money cprice" data-currency="${current_currency}">
                                  ${original_price}</span>
                                </h4>`;
                }
              if(eam_complete_options == undefined){
                    
                addon_product = '<div class="eam-cc-addon-product" data-product-id="'+current_product.id+'" data-product-handle="'+current_product.handle+'"> <div class="eam-cc-addon-product-top"> <a href="'+url+'"> <img alt="" class="eam-cc-addon-product-image " src="'+featured_image+'"> </a> <div class="eam-header-price-container"> <div class="loox-rating" data-id="" data-rating="" data-raters=""></div> <a href="'+url+'"> <h4 class="eam-cc-addon-product-title">'+current_product.title+'</h4> </a> <a class="eam-cc-addon-product-price-container" href="'+url+'"> '+price_html+' </a> <a class="eam-cc-addon-product-button-container" href="#"> <button class="'+atc_class+'" data-product-url="'+url+'" data-product-handle="'+current_product.handle+'" data-product-id="'+first_variant_id+'">'+atc_text+'</button> </a> </div> </div></div>'
              }else{
                addon_product = '<div class="eam-cc-addon-product" data-product-id="'+current_product.id+'" data-product-handle="'+current_product.handle+'"> <div class="eam-cc-addon-product-top"> <a href="'+url+'"> <img alt="" class="eam-cc-addon-product-image " src="'+featured_image+'"> </a> <div class="eam-header-price-container"> <div class="loox-rating" data-id="" data-rating="" data-raters=""></div> <a href="'+url+'"> <h4 class="eam-cc-addon-product-title">'+current_product.title+'</h4> </a> <a class="eam-cc-addon-product-price-container" href="'+url+'"> '+price_html+' </a> <a class="eam-cc-addon-product-button-container" href="#"> <button class="'+atc_class+'" data-product-url="'+url+'" data-product-handle="'+current_product.handle+'" data-product-id="'+current_product.id+'">'+atc_text+'</button> </a> </div> </div><div class="eam-cc-addon-product-bottom">'+eam_complete_options+'</div> </div>'
              }
              $('.eam-cart-addon-item-container').append(addon_product);
            }
          }
          if($('.eam-cc-addon-product').length==0){
            $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">Collection Complete</p>')
          }
        }else{
          RenderCartAddons_2();
          // $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">Collection Complete</p>')
        }
        if($('.eam-cc-addon-product').length>3){
            $('.eam-cart-addon-item-load-more').show();
            
        }else{
          $('.eam-cart-addon-item-load-more').hide();
        }
      });      
            
  
       
    }
  
    function EamFreeProduct(cart){
      if(cart.items.length>0){
        var free_gift_variant_id = free_gift_product_variant;
        var free_product_length=$('.eam-cart-item.free-item[data-product-handle="'+free_gift_product_handle+'"]').length;
        var current_cart_price = cart.total_price/100.00;
        if(current_cart_price>=free_gift_price){
          localStorage.setItem('add_item','true');
        }else{
          localStorage.setItem('add_item','false');
        }
        
        if(free_product_length<=0 && localStorage.getItem('add_item') == 'true'){
          addItemGeneric(free_gift_variant_id,1);
        }else if(free_product_length > 0 && localStorage.getItem('add_item') == 'false'){
          free_gift_variant_id=$('.eam-cart-item.free-item[data-product-handle="'+free_gift_product_handle+'"]').data('product-line');
          change_item_quantity(free_gift_variant_id,0);
        }
      }else{
        localStorage.setItem('item_added','false');
      }
  
    }
  
    function addItemGeneric(variant_id,quantity) {
       $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: {
            id: variant_id,
            quantity: quantity
          },
          success: addToCartfreeOk
       });
    }
    function addToCartfreeOk(product) { 
      openMainCart();
    }
  
  
  // Set Upsell
  // if(enable_upsell){
  //   document.querySelector('.eam-upsell-close-icon').addEventListener('click',function(){
  //     document.querySelector('.eam-upsell-main-container').style.display='none'; 
  //     upsell_triggered[handle] = true;
  //     opemEamCart();
      
  //   });
  //   document.querySelector('.eam-upsell-overlay').addEventListener('click',function(){
  //     document.querySelector('.eam-upsell-main-container').style.display='none'; 
  //     upsell_triggered[handle] = true;
  //     opemEamCart();
  //   });
    
  //   function show_upsell(){
  //     window.localStorage.setItem('filter_product',JSON.stringify(upsell_triggered));
  //     jQuery.getJSON('/cart.js', function(cart) {
  //       if(cart.items.length>0){
  //         var item_found = cart.items.filter(function(item) {
  //           var handle;
  //           if(enable_variant_upsell){
  //              handle = item.handle+"?variant="+ item.id;
  //           }else{
  //             handle = item.handle;
  //           }
  //           if(upsell_handles[handle]!=undefined){
  //             return upsell_handles[handle];
  //           }
  //         });
  //         var current_upsell_handle,upsell_item_exist;
  //         if(item_found.length>0){
  //           if(enable_variant_upsell){
  //             handle = item_found[0].handle+"?variant="+item_found[0].id;
  //           }else{
  //             handle = item_found[0].handle;
              
  //           }
  //           current_upsell_handle = upsell_handles[handle];
  //           var current_vid;
            
  //           if(enable_variant_upsell && current_upsell_handle!=undefined){
  //             current_vid = current_upsell_handle.split('?variant=')[1];
  //             current_upsell_handle = current_upsell_handle.split('?variant=')[0];
  //           }
  //           upsell_item_exist = cart.items.filter(function(item) {
  //             if(item.handle == current_upsell_handle){
  //               return item;
  //             }
  //           });
            
  //         }
  //         if(item_found.length>0 && upsell_item_exist.length ==0 && !upsell_triggered[handle]){
  //           jQuery.getJSON(window.Shopify.routes.root + 'products/'+current_upsell_handle+'.js', function(product) {
              
  //             var selected_variant = product.variants.filter(function(variant) {
  //               if(variant.id == current_vid){
  //                 return variant
  //               }
  //             });
              
  //             if(selected_variant.length == 0){
  //               selected_variant = product.variants[0];
  //             }else{
  //               selected_variant = selected_variant[0];
  //             }
  //             var variant_id = selected_variant.id;
  //             var product_price = current_currency+''+((selected_variant.price * 0.5)/ 100.00).toFixed(2);
  //             var original_price = current_currency+''+(selected_variant.price / 100.00).toFixed(2);
  //             var new_image=product.images[0];
  //             if(selected_variant.featured_image!=null){
  //               new_image = selected_variant.featured_image.src;
  //             }
  //             document.querySelector('.eam-upsell-image').src = new_image;
  //             document.querySelector('.eam-upsell-atc-price').innerText = product_price;
  //             document.querySelector('.eam-upsell-main-container').style.display='block';
  //             document.querySelector('.eam-upsell-atc').dataset.variantId = variant_id;
  //           });
  //         }else{
  //           opemEamCart();
  //         }
  //       }else{
  //         opemEamCart();
  //       }
  //     });
      
  //   }
    
  //   document.querySelector('.eam-upsell-atc').addEventListener('click',function(e){
  //     var variant_id = this.dataset.variantId;
  //     document.querySelector('.eam-upsell-main-container').style.display='none';
  //     addItemGeneric(variant_id,1);
      
  //   });
  // }
  
  
  // Order Note
  if(enable_order_note){
     $('.eam-custom-ordernote-icon').on("click",function(){
      $('.eam-custom-ordernote-data-container').slideToggle();
    });
    $('.eam-custom-ordernote-cancel').on("click",function(){
      $('.eam-custom-ordernote-data-container').slideToggle();
    });
    $('#eam-custom-ordernote').on("change",function(){
      var current_note=$('#eam-custom-ordernote').val();
      $('.eam-custom-ordernote-container').show();
      if($('.eam-custom-edit-ordernote-text').length<1){
        $('.eam-custom-ordernote-data-heading').text('Edit '+order_note_text);
        $('.eam-custom-ordernote-container .eam-custom-ordernote-icon').append('<p class="eam-custom-edit-ordernote-text">Edit note</p>');
      } 
      $('.eam-custom-ordernote-text').addClass('edit-order-note-text');  
      $('.eam-custom-ordernote-text').text(current_note);
      $('.eam-custom-ordernote-text').css('color','#979797');
      $.ajax({
          url: '/cart/update.js',
          type: 'POST',
          data: {note: current_note},
          success: function(result) { 
          }
      });
    });
  }
  
  // $(document).on('click','.eam-cart-bottom-container .pw-switch',function(){
  //     var rj=0;
  //     route_load_cart_items(rj);
     
  // });
  
  
  // function route_load_cart_items(rj){
  //   rj++;
  //   $('.route-div').hide();
  //      $('.loading-gif').show();
  //     setTimeout(function(){
  //       jQuery.getJSON('/cart.json', function(cart) {
  //         if(cart.items.length>0 || rj==5){
  //           $('.eam-cart-addon-item-container').addClass('eam-cart-addon-empty');
  //           $('.eam-cart-free-shipping-text-container .eam-cart-free-shipping-disclaimer').hide();
  //           RenderCartItem(cart);
  //           $('.route-div').show();
  //           $('.loading-gif').hide();
  //         }else{
  //           route_load_cart_items(rj)
  //         }
  //       });
  //     },2000)
  // }
  
  document.querySelector('.eam-checkout-cart-button').addEventListener('click',function() {
    this.classList.add('eam-checkout-loading');
    this.textContent = 'Please Wait...';
    if(document.querySelector("body").classList.contains("eam-pendantLP-v1")){
     window.location.href = '/checkout?discount=PENDANT20';
    }else{
    window.location.href="/checkout";
    }
  })
  
  $(document).on('click','.eam-cart-addon-item-load-more',function() {
    if($('.eam-cc-addon-product').length>3){
        $('.eam-cart-addon-item-load-more').show();
        if($('.eam-cart-addon-item-load-more').text()=="Load More"){
            $('.eam-cc-addon-product:hidden').show();
            $(this).text('Show Less');      
        }else{
          $('.eam-cc-addon-product:nth-child(n+4)').hide();
          $(this).text('Load More');    
        }
    }else{
      $('.eam-cart-addon-item-load-more').hide();
    }
  
  
  })
  
  
  // $(window).on('popstate', function() {
  //   reloadDivContent()
  // });
  
  function reloadDivContent() {
    // Specify the URL of the content to load
    var url = window.location.href;
  
    // Specify the selector for the specific content within the div
    var contentSelector = '.eam-cart-bottom-content';
  
    // Use the load() function with the selector to reload the specific content
    $(contentSelector).load(url + ' ' + contentSelector);
  }
  
  
  
  
  if (window.location.href.includes('openSlider=true')) {
      opemEamCart();
  }
  
  